<template>
  <div>
    <v-overlay :value="loading" absolute>
      <v-progress-circular indeterminate size="64" color="primary" />
    </v-overlay>
    
    <div v-if="!loading">
      <app-form
        v-bind:parentObject="{
          data: this.formData,
          searchnew: this.search,
          pageTitle: this.pageTitle,
          errMsg: this.errMsg,
          isEdit: this.editMode,
        }"
        v-on:input="formData = $event"
        v-on:save="saveHandler"
        v-on:delete="isConfirm = !isConfirm"
        v-on:error="errorHandler"
      />

      <div v-if="isErr">
        <app-error
          v-bind:parentError="{
            data: this.errMsg,
            isErr: this.isErr,
          }"
          v-on:closeError="isErr = $event"
        />
      </div>
      <div v-if="isConfirm">
        <app-confirm
          v-bind:parentObject="{
            pageTitleValue: this.pageTitleValue,
            isConfirm: this.isConfirm,
          }"
          v-on:confirm="deleteHandler($event)"
          v-on:cancelConfirm="isConfirm = !isConfirm"
        />
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";

import DocumentRecordForm from "../../../components/personnel/documentrecord/Form";
import ErrorDialog from "../../../components/common/ErrorDialog";
import ConfirmDialog from "../../../components/common/ConfirmDialog";

export default {
  components: {
    "app-form": DocumentRecordForm,
    "app-error": ErrorDialog,
    "app-confirm": ConfirmDialog,
  },

  data() {
    return {
      id: this.$route.params.id,
      search: this.$route.params.search,
      pageTitle: this.$t('recdocrec.editdocrec'),
      pageTitleValue: "",
      formData: {
        psnid: null,
        staffid: null,
        staffcode: null,
        compnyid: null,
        staffdocid: null,
        doctypeid: null,
        docno: null,
        startdate: null,
        enddate: null,
        attach: null,
        remark: null,
        stamp: null,
        userid: this.$store.getters.userId,
      },
      documentRecordHolder: null,
      documentDetailRecordHolder: null,
      errMsg: "",
      isErr: false,
      editMode: true,
      loading: true,
      isConfirm: false,
    };
  },

  methods: {
    errorHandler($event) {
      this.isErr = $event.isErr;
      this.errMsg = $event.errMsg;
    },

    saveHandler() {
      let vm = this;
      if (!this.CheckPermission(this.$route.meta.funcname, "canedit")) {
        return false;
      }
      this.$store.dispatch('put', {url: "/documentrecord/" + this.id, payload: this.formData})
        .then((res) => {
          if (res.data.status == 201) {
            vm.$router.push({ name: "documentrecordlist", params: { search: this.search}  });
          } else {
            vm.isErr = !vm.isErr;
            vm.errMsg = res.data.error;
          }
        })
        .catch((err) => {
          vm.isErr = !vm.isErr;
          vm.errMsg = err;
        });
    },

    deleteHandler() {
      const vm = this;
      if (!this.CheckPermission(this.$route.meta.funcname, "candelete")) {
        return false;
      }
      this.$store.dispatch('delete', {url:
            "/documentrecord/" +
            this.documentRecordHolder.id +
            "/" +
            this.formData.userid,
          payload: { data: this.formData }})
        .then((res) => {
          if (res.data.status == 200) {
            vm.$router.push({ name: "documentrecordlist" });
          } else {
            vm.isErr = !vm.isErr;
            vm.errMsg = res.data.error;
          }
        })
        .catch((err) => {
          vm.isErr = !vm.isErr;
          vm.errMsg = err;
        });
    },

    loadDocumentRecordDetails() {
      const vm = this;

      return this.$store.dispatch('get', {url: "/documentrecordd/" + this.id})
        .then((res) => {
          vm.documentDetailRecordHolder = res.data.rec[0];

          

          this.loadDocumentRecord(vm.documentDetailRecordHolder);
        })
        .catch((err) => {
          vm.isErr = !vm.isErr;
          vm.errMsg = err;
        });
    },

    loadDocumentRecord(item) {
      const vm = this;
      //vm.loading = true;

      this.$store.dispatch('get', {url: "/documentrecord/" + item.staffdocid})
        .then((res) => {
          vm.documentRecordHolder = res.data.rec[0];

          this.formData.staffid = item.staffid;
          this.formData.staffcode = item.staffcode;
          this.formData.staffdocid = item.staffdocid;
          this.formData.compnyid = vm.documentRecordHolder.compnyid;
          this.formData.doctypeid = vm.documentRecordHolder.doctypeid;
          this.formData.docno = item.docno;
          this.formData.startdate = moment(item.startdate).format("YYYY-MM-DD");
          this.formData.enddate = moment(item.enddate).format("YYYY-MM-DD");
          this.formData.attach = item.attach;
          this.formData.attachname = item.attachname;
          this.formData.remark = item.remark;
          this.formData.stamp = item.stamp;

          vm.formData.lockstaff = res.data.rec[0].lockstaff;

          vm.loading = false;
        })
        .catch((err) => {
          vm.isErr = !vm.isErr;
          vm.errMsg = err;
        });
    },
  },

  async mounted() {
    this.editMode = true;
    await this.loadDocumentRecordDetails();
  },
};
</script>